import React, {Component} from 'react'
import {observer} from 'mobx-react';
import ConfigurationEditor from './Editor'
import ConfigurationAPIService from '@lib/api-services/ConfigurationAPIService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import buildResourcePath from '@lib/buildResourcePath'
import Modal from '@lib/components/common/Modal';
import store from '@lib/store/configuration';
import Dropdown from '../common/DropdownReact';
import Button from '../common/Button';
import EditPageSubstationDocsGenerateModal from './edit-page/EditPageSubstationDocsGenerateModal';
import EditPageDeliveryDocsGenerateModal from './edit-page/EditPageDeliveryDocsGenerateModal';
import EditPageXlsDocsGenerateModal from './edit-page/EditPageXlsDocsGenerateModal';
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';
import Loader from '../common/Loader';
import IconSave from '../icons/IconSave';

const ConfigurationEditPage = observer(
    class ConfigurationEditPage extends Component {
        configurationEditorComponentClass = ConfigurationEditor

        static defaultProps = {
            configurationAPIService: ConfigurationAPIService
        }

        state = {
            modalDeleteIsOpen: false,
            substationDocsModalOpen: false,
            specForOrderProcessingXlsDocsModalOpen: false,
            deliveryDocsModalOpen: false,
            docsSelectedLanguageId: 0,
            _forceUpdate: false
        }

        constructor(props) {
            super(props);

            scheduleAtDocumentReady(() => {
                this.configurationAPIService = APIServicesRegistry.getService(this.props.configurationAPIService)
                this.setState({_forceUpdate: !this.state._forceUpdate});
            });

            this.save = this.save.bind(this)
        }

        onRemoveButtonClick = () => {
            store.duringDelete = true;
            this.configurationAPIService.delete(this.props.id.value).then(() => {
                window.location.href = buildResourcePath('Configurations')
            });
        }

        onCopyButtonClick = () => {
            store.duringCopy = true;
            this.configurationAPIService.copy(this.props.id.value)
        }

        onDocsGenerateDropdownItemClick = item => {
            switch (item.id) {
                case 0:
                    this.setState({substationDocsModalOpen: true});
                    break;

                case 1:
                    this.setState({deliveryDocsModalOpen: true});
                    break;

                case 2:
                    this.setState({specForOrderProcessingXlsDocsModalOpen: true})
                    break;
            }
        }

        save() {
            var a = !store.canSave();
            var b = store.hasIssuesAsForceToChange();

            if (a || b)
                return;

            store.setDuringSave(true);

            store.setDirty(false);

            var model = store.getTransformedFormModel()
            model.id = this.props.id.value

            this.configurationAPIService.saveConfiguration(model).then(() => {
                $('.page-body-loader').fadeOut(150)
                store.setDuringSave(false);
            }).catch(() => {
                $('.page-body-loader').fadeOut(150)
                store.setDuringSave(false);
            })


        }

        getProjectUrl = (projectId) => {
            return buildResourcePath(`/Project/Edit/${projectId.value}`);
        }

        setModalDeleteIsOpen = value => this.setState({modalDeleteIsOpen: value})

        render() {
            const EditorComponent = this.configurationEditorComponentClass
            var model = store.getTransformedFormModel();
            var configurationName = model === null ? this.props.generalInformation.name.value : model.generalInformation.name;
            return (
                <div className="configuration-page">

                    {this.renderDeleteModal()}

                    <div className="page-body-container page-container" style={{position: 'relative'}}>
                        {(store.duringCopy || store.duringSave) && <Loader fillContainer={true} showBalls={false}/>}
                        {this.props.generalInformation.project.value &&

                            <div className="btn-go-back">
                                <span>&#x2190;</span>
                                <a className="btn-show-all"
                                   href={this.getProjectUrl(this.props.generalInformation.projectId)}> {__('Go back to') + ' ' + this.props.generalInformation.project.value}</a>
                            </div>
                        }
                        <div className="page-body-titlebar">
                            <h3 className="page-body-title">
                                {configurationName}
                            </h3>

                            <div className="page-body-action-buttons">
                                {this.renderActionButtons()}
                            </div>
                        </div>
                        {this.renderModals()}
                        <EditorComponent {...this.props} save={() => this.save()}/>
                    </div>
                </div>
            )
        }

        renderModals() {
            return <React.Fragment/>
        }

        renderDeleteModal() {
            return (
                <Modal isOpen={this.state.modalDeleteIsOpen} onClose={() => this.setModalDeleteIsOpen(false)}>
                    <Modal.Header>{__('Remove')}</Modal.Header>
                    <Modal.Body>
                        {store.duringDelete && <Loader fillContainer={true}/>}
                        {__('Do you want to remove this configuration?')}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="button-v2 button-size-default button-theme-border-only button-color-default"
                                onClick={() => this.setModalDeleteIsOpen(false)}>{__('Cancel')}</button>
                        <button className="button-v2 button-size-default button-theme-border-only button-color-default"
                                onClick={this.onRemoveButtonClick}>{__('Delete')}</button>
                    </Modal.Footer>
                </Modal>
            )
        }

        getDocumentationApi() {
            return this.configurationAPIService;
        }

        createDocumentationDropdown() {
            var api = this.getDocumentationApi();
            let model = store.getTransformedFormModel();
            let isCustom = model === null ? false : model.unitType.isCustom;
            const docsGenerateItems = [
                {id: 0, label: __('Substation documentation')},
            ]
            if (this.props.hasDeliveryDocumentationPermission && !isCustom)
                docsGenerateItems.push({id: 1, label: __('Delivery documentation')})

            if (this.props.hasSpecificationForOrderProcessingXlsPermission)
                docsGenerateItems.push({id: 2, label: __('Spec for order processing (XLS)')})

            return (
                <div className="page-body-action-buttons-generate-documentation">
                    <EditPageSubstationDocsGenerateModal
                        api={api}
                        id={this.props.id.value}
                        isOpen={this.state.substationDocsModalOpen}
                        onClose={() => this.setState({substationDocsModalOpen: false})}
                    />

                    <EditPageDeliveryDocsGenerateModal
                        api={api}
                        id={this.props.id.value}
                        isOpen={this.state.deliveryDocsModalOpen}
                        onClose={() => this.setState({deliveryDocsModalOpen: false})}
                    />

                    <EditPageXlsDocsGenerateModal
                        api={api}
                        id={this.props.id.value}
                        isOpen={this.state.specForOrderProcessingXlsDocsModalOpen}
                        onClose={() => this.setState({specForOrderProcessingXlsDocsModalOpen: false})}
                    />

                    <Dropdown items={docsGenerateItems} caption={__("Generate documentation")}
                              onItemClick={this.onDocsGenerateDropdownItemClick}/>
                </div>
            )
        }

        renderActionButtons() {
            return (
                <React.Fragment>
                    {!this.isNewConfiguration() && (
                        <React.Fragment>
                            {this.props.hasDocumentationPermission && this.createDocumentationDropdown()}
                            <div className="desktop-only">
                                <React.Fragment>
                                    {this.getDesktopActionButtons()}
                                </React.Fragment>
                            </div>

                            <div className="configuration-edit-page-floaters mobile-only">
                                <ExpandableFloatingDropdown>
                                    {this.getMobileActionButtons()}
                                </ExpandableFloatingDropdown>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )
        }

        getDesktopActionButtons() {
            var buttons = []
            buttons.push(<Button key={1} processing={store.duringCopy}
                                 onClick={() => this.onCopyButtonClick()}>{__('Copy')}</Button>)
            buttons.push(<Button key={3} onClick={() => this.setModalDeleteIsOpen(true)}>{__('Delete')}</Button>)
            buttons.push(<Button key={2} processing={store.duringSave} theme={Button.Theme.BorderOnly}
                                 disabled={!store.canSave() || store.hasIssuesAsForceToChange()} icon={IconSave}
                                 className="button-save" onClick={() => this.save()}>{__('Save')}</Button>)

            return buttons;
        }

        getMobileActionButtons() {
            var buttons = []
            buttons.push(<ExpandableFloatingDropdown.Item key={0}
                                                          onClick={() => this.onCopyButtonClick()}>Copy</ExpandableFloatingDropdown.Item>)
            buttons.push(<ExpandableFloatingDropdown.Item key={1}
                                                          onClick={() => this.save()}>Save</ExpandableFloatingDropdown.Item>)

            if (this.props.hasDocumentationPermission)
                buttons.push(<ExpandableFloatingDropdown.Item key={2}
                                                              onClick={() => this.setModalDeleteIsOpen(true)}>Delete</ExpandableFloatingDropdown.Item>)

            return buttons;
        }

        isNewConfiguration() {
            return this.props.id.value === 0
        }
    }
)

window.components.ConfigurationEditPage = ConfigurationEditPage
export default ConfigurationEditPage